import React from "react";
import PropTypes from "prop-types";
import noop from "lodash-es/noop";
import { difference } from "lodash-es";

class YMap extends React.Component {
    constructor(props) {
        super(props);

        this.map = null;

        this.addPlaceMarks = this.addPlaceMarks.bind(this);
        this.addClusterer = this.addClusterer.bind(this);
        this.initMap = this.initMap.bind(this);
        this.setCenter = this.setCenter.bind(this);
        this.onClick = this.onClick.bind(this);
        this.setDefaultIconPlaceMarks = this.setDefaultIconPlaceMarks.bind(
            this
        );
        this.selectPlaceMark = this.selectPlaceMark.bind(this);
        this.selectPlaceMarkById = this.selectPlaceMarkById.bind(this);
        this.createCustomLayout = this.createCustomLayout.bind(this);
    }

    componentDidMount() {
        this.initMap();
    }

    componentWillUnmount() {
        if (this.map) {
            this.map.destroy();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.map) {
            if (
                this.props.placeMarks !== prevProps.placeMarks ||
                this.props.polygons !== prevProps.polygons
            ) {
                this.map.geoObjects.removeAll();

                if (this.props.withCluster) {
                    this.addClusterer(this.props.placeMarks);
                } else {
                    this.addPlaceMarks(this.props.placeMarks);
                }
                this.addPolygons(this.props.polygons);
            }

            if (this.props.selectedPlaceMarkId) {
                this.selectPlaceMarkById(this.props.selectedPlaceMarkId);
            }

            if (difference(this.props.center, prevProps.center).length !== 0) {
                this.setCenter();
            }
        }
    }

    onClick(event) {
        const target = event.get(`target`);
        this.selectPlaceMark(target);
        this.props.onClickPlaceMark(target.properties.get(`id`));
        this.map.container.fitToViewport(); // костыль для обновления карты при выборе точки
    }

    setCenter(object = null) {
        if (object) {
            this.map.setCenter(object.geometry.getCoordinates(), 13);
        } else if (
            (this.props.placeMarks && this.props.placeMarks.length > 1) ||
            (this.props.polygons && this.props.polygons.length > 0)
        ) {
            this.map.setBounds(this.map.geoObjects.getBounds());
        } else {
            this.map.setCenter(this.props.center);
        }
    }

    setDefaultIconPlaceMarks() {
        const objects = window.ymaps.geoQuery(this.map.geoObjects);

        objects.setOptions({
            iconImageHref: `/images/map-point.svg`,
            iconImageSize: [50, 50],
        });
    }

    selectPlaceMarkById(id) {
        const objects = window.ymaps.geoQuery(this.map.geoObjects);
        const searchResult = objects.search(`properties.id = ${id}`);
        this.selectPlaceMark(searchResult.get(0)); // поиск всегда возвращает коллекцию, но в нашем случае результатом будет всегда одна точка
    }

    selectPlaceMark(placeMark) {
        if (!placeMark) {
            return;
        }

        this.setDefaultIconPlaceMarks();

        placeMark.options.set({
            iconImageHref: `/images/point_active.svg`,
            iconImageSize: [36, 45],
        });

        this.setCenter(placeMark);
    }

    addPlaceMarks(placeMarks) {
        if (!placeMarks || placeMarks.length <= 0) {
            return;
        }

        placeMarks.forEach((mark) => {
            const placemark = new window.ymaps.Placemark(
                mark.coords,
                {
                    id: mark.id,
                    ...(mark.properties || {}),
                },
                {
                    ...(mark.options || {}),
                    ...(this.props.isSchool && {
                        iconLayout: this.createCustomLayout(
                            mark.playgroundName,
                            mark.playgroundId
                        ),
                    }),
                }
            );

            if (this.props.onClickPlaceMark) {
                placemark.events.add(`click`, this.onClick);
            }

            this.map.geoObjects.add(placemark);
        });
    }

    addClusterer(markers) {
        const MyBalloonLayout = window.ymaps.templateLayoutFactory.createClass(
            '<div class="balloon top" id="balloon">' +
                '<div class="arrow"></div>' +
                '<div class="balloon__inner">' +
                "$[[options.contentLayout display=initial observeSize width=100% minWidth=446 maxWidth=446 minHeight=76]]" +
                "</div>" +
                "</div>",
            {
                build: function () {
                    this.constructor.superclass.build.call(this);

                    this._element = this.getParentElement().querySelector(
                        ".balloon"
                    );

                    this._onCloseClick = this.onCloseClick.bind(this);

                    this.applyElementOffset();
                },
                clear: function () {
                    this.constructor.superclass.clear.call(this);
                },
                onSublayoutSizeChange: function () {
                    MyBalloonLayout.superclass.onSublayoutSizeChange.apply(
                        this,
                        arguments
                    );

                    if (!this._isElement(this._element)) {
                        return;
                    }

                    this.applyElementOffset();

                    this.events.fire("shapechange");
                },
                applyElementOffset: function () {
                    Object.assign(this._element.style, {
                        left: -(this._element.offsetWidth / 2) + "px",
                        top:
                            -(
                                this._element.offsetHeight +
                                this._element.querySelector(".arrow")
                                    .offsetHeight
                            ) + "px",
                    });
                },
                onCloseClick: function (e) {
                    e.preventDefault();

                    this.events.fire("userclose");
                },
                getShape: function () {
                    if (!this._isElement(this._element)) {
                        return MyBalloonLayout.superclass.getShape.call(this);
                    }

                    var style = getComputedStyle(this._element);
                    var position = {
                        left: parseFloat(style.left),
                        top: parseFloat(style.top),
                    };

                    return new window.ymaps.shape.Rectangle(
                        new window.ymaps.geometry.pixel.Rectangle([
                            [position.left, position.top],
                            [
                                position.left + this._element.offsetWidth,
                                position.top +
                                    this._element.offsetHeight +
                                    this._element.querySelector(".arrow")
                                        .offsetHeight,
                            ],
                        ])
                    );
                },
                _isElement: function (element) {
                    return element && element.querySelector(".arrow");
                },
            }
        );

        const MyBalloonClusterContentLayout = () => {
            const cards = [
                "<ul class=balloon__list>",
                "{% for geoObject in properties.geoObjects %}",
                "<li>{{ geoObject.properties.balloonContent|raw }}</li>",
                "{% endfor %}",
                `{{geoObjects}}`,
                "</ul>",
            ].join("");

            return window.ymaps.templateLayoutFactory.createClass(cards);
        };

        const circleClusterLayout = window.ymaps.templateLayoutFactory.createClass(
            '<div class="sportcourts-rent__cluster-placemark">{{ properties.geoObjects.length }}</div>'
        );

        const clusterIcons = [
            {
                href: "",
                size: [40, 40],
                offset: [-20, -20],
            },
        ];

        const clusterer = new window.ymaps.Clusterer({
            clusterDisableClickZoom: true,
            gridSize: 64,
            clusterIcons: clusterIcons,
            clusterIconContentLayout: circleClusterLayout,
            clusterIconShape: {
                type: "Circle",
                coordinates: [0, 0],
                radius: 30,
            },
            balloonLayout: MyBalloonLayout,
            clusterBalloonContentLayout: MyBalloonClusterContentLayout(),
            // hideIconOnBalloonOpen: false,
            balloonPanelMaxMapArea: this.props.isMobile ? Infinity : 0,
            balloonMinHeight: this.props.isMobile && 356,
            balloonPanelMaxHeightRatio: this.props.isMobile && 0.6,
        });

        markers.forEach((markerData) => {
            const marker = new window.ymaps.Placemark(
                markerData.coords,
                {
                    id: markerData.properties.id,
                    ...(markerData.properties || {}),

                    balloonContent: markerData.balloonContentLayout,
                },
                {
                    balloonShadow: false,
                    balloonLayout: MyBalloonLayout,
                    balloonContentLayout: window.ymaps.templateLayoutFactory.createClass(
                        markerData.balloonContentLayout
                    ),
                    balloonPanelMaxMapArea: this.props.isMobile ? Infinity : 0,
                    balloonMinHeight: this.props.isMobile && 314,
                    balloonPanelMaxHeightRatio: this.props.isMobile && 0.6,
                    // hideIconOnBalloonOpen: false,
                    iconLayout: window.ymaps.templateLayoutFactory.createClass(
                        markerData.placemarkLayout
                    ),
                    iconShape: {
                        type: "Circle",
                        coordinates: [0, 0],
                        radius: 25,
                    },
                }
            );

            if (this.props.isMobile) {
                marker.events.add("click", function (e) {
                    const data =
                        e?.originalEvent?.target?.properties?._data?.complex;
                    markerData.properties.complexesForModal([data]);
                });
            }

            clusterer.add(marker);
        });

        if (this.props.isMobile) {
            clusterer.events.add("click", function (e) {
                const target = e.get("target");
                const geoObjects = target.getGeoObjects();
                const complexesData = geoObjects.map(
                    (object) => object.properties?._data?.complex
                );
                const openModal =
                    geoObjects[0]?.properties?._data?.complexesForModal;
                openModal(complexesData);
            });
        }

        this.map.geoObjects.add(clusterer);
    }

    createCustomLayout(playgroundName, playgroundId) {
        const logoUrl = this.props.logoUrl;
        const isSelected = this.props.selectedId == playgroundId;
        const layout = `
          <div class="school__placemark ${
              isSelected ? "school__placemark_selected" : ""
          }" >
          <div class="person__avatar school__placemark-logo">
            
          ${
              logoUrl
                  ? `<img src="${logoUrl}" class="school__placemark-logo"></img>`
                  : ""
          }
        </div>
            <span class="school__placemark-text">${playgroundName}
          </div>
        `;

        return window.ymaps.templateLayoutFactory.createClass(layout);
    }

    addPolygons(polygons) {
        if (!polygons || polygons.length <= 0) {
            return;
        }

        polygons.forEach(({ geometry, properties, options }) => {
            this.map.geoObjects.add(
                new window.ymaps.Polygon(geometry, properties, options)
            );
        });
    }

    addClickHandler(handler) {
        this.map.events.add("click", (event) => {
            handler(event);
        });
    }

    initMap() {
        if (!window.ymaps) {
            return;
        }

        window.ymaps.ready(() => {
            this.map = new window.ymaps.Map(
                this.props.id,
                {
                    center: this.props.center,
                    zoom: this.props.zoom,
                    controls: this.props.controls,
                },
                {
                    suppressMapOpenBlock: true,
                    yandexMapDisablePoiInteractivity: true,
                    clusterize: true,
                }
            );

            if (this.props.noScrollZoom) {
                this.map.behaviors.disable(["scrollZoom"]);
            }

            if (this.props.withCluster) {
                this.addClusterer(this.props.placeMarks);
                this.map.setZoom(this.props.zoom);
            } else {
                this.addPlaceMarks(this.props.placeMarks);
            }

            this.addPolygons(this.props.polygons);
            this.addClickHandler(this.props.onClickMap);

            if (!this.props.withCluster) {
                this.setCenter();
            }

            if (this.props.selectedPlaceMarkId) {
                this.selectPlaceMarkById(this.props.selectedPlaceMarkId);
            }

            this.props.refMap(this.map);

            this.map.events.add("click", () => {
                if (this.map.balloon.isOpen()) {
                    this.map.balloon.close();
                }
            });
        });
    }

    render() {
        return (
            <div
                id={this.props.id}
                className="map"
                style={{
                    width: this.props.width,
                    height: this.props.height,
                }}
            />
        );
    }
}

YMap.defaultProps = {
    id: `map`,
    width: `100%`,
    height: undefined,
    zoom: 12,
    controls: [`zoomControl`],
    refMap: noop,
    noScrollZoom: false,
    onClickMap: noop,
};

YMap.propTypes = {
    id: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    center: PropTypes.arrayOf(PropTypes.number), // Массив из долготы и широты
    zoom: PropTypes.number,
    controls: PropTypes.arrayOf(PropTypes.string),
    placeMarks: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            coords: PropTypes.arrayOf(
                PropTypes.oneOfType([PropTypes.number, PropTypes.string])
            ),
            properties: PropTypes.object,
            options: PropTypes.object,
        })
    ),
    polygons: PropTypes.arrayOf(
        PropTypes.shape({
            // Два массива массивов координат. В первом массиве внешний контур, во втором внутренний.
            geometry: PropTypes.arrayOf(
                PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
            ).isRequired,
            properties: PropTypes.object,
            options: PropTypes.object,
        })
    ),
    onClickMap: PropTypes.func,
    onClickPlaceMark: PropTypes.func,
    selectedPlaceMarkId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    refMap: PropTypes.func,
    noScrollZoom: PropTypes.bool.isRequired,
    isSchool: PropTypes.bool,
    logoUrl: PropTypes.string,
    selectedId: PropTypes.number,
    isMobile: PropTypes.bool,
    withCluster: PropTypes.bool,
};

export default YMap;
